import React from 'react';
import { v4 as uuid4 } from 'uuid';
import { withRouter as withReactRouter} from 'react-router-dom';

export const withRouter = (Component) => {
    const hoc = (props) => {
        let urlSearchParams = new URLSearchParams(props.history.location.search);

        const getUrlSearchParam = (name) => {
            let param = urlSearchParams.get(name);
            return (!param) ? '' : param;
        };

        const reload = () => {
            urlSearchParams = new URLSearchParams();
            urlSearchParams.set('uuid', uuid4());
            props.history.push({search: urlSearchParams.toString()});
        };

        return <Component {...props} router={{
            urlSearchParams: urlSearchParams,
            getUrlSearchParam: getUrlSearchParam,
            reload: reload,
        }}/>;
    };
    hoc.displayName = 'withRouter';
    return withReactRouter(hoc);
};
